<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.ProductBatchNo" :placeholder="$tt('生产批次号')">
					<span slot="prepend">{{$tt('生产批次号')}}</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.EquipmentSerialNo" :placeholder="$tt('设备序列号')">
					<span slot="prepend">{{$tt('设备序列号')}}</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.MachineCode1" :placeholder="$tt('机器码1')">
					<span slot="prepend">{{$tt('机器码1')}}</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.MachineCode2" :placeholder="$tt('机器码2')">
					<span slot="prepend">{{$tt('机器码2')}}</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			</FormItem>
		</Form>
		<!-- <Table :columns="columns1" :data="data1" :height="tableHeight" size="small">
			<div slot="footer"><MyPage ref="sonPage" :param="pageParam" :url="getInfoUrl" @listData='getDeviceData'></MyPage></div>
		</Table> -->
		<PageTable ref="table" :columns="columns1" :tableHeight="tableHeight" :url="getInfoUrl" :queryParam="pageParam"></PageTable>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	// import expandRow from './StationManagementExpand.vue';
	// import gaodeMap from '../../../js/GaodeMapMethod.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	import commonFuncs from '../../../js/commonFuncs.js';
	import PageTable from '../../public/PageTable/PageTable.vue';
	export default {
		components: {
			PageTable
		},
		data() {
			return {
				getInfoUrl: webapi.base_api_url + '/BoardTest/GetBoardEquipment',
				// occupyPriceList: [],
				zindex: 2000,
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				// SelectStation: "",
				tableHeight: "650",
				// modal: {
				// 	Title: this.$tt('场站添加'),
				// 	type: "addStation"
				// },
				// modalView: false,

				//图片上传组件数据
				// defaultList: [],
				// upHeader: {
				// 	'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				// },
				// imgName: '',
				// visible: false,
				// uploadList: [],
				//新增图片删除缓存，实际点击保存才删除
				// PictureDelCache: [],
				//原始图片删除缓存
				// PictureUpCache: [],
				/******分割线********/

				//地图modal
				// center: [114.198595, 22.633595],
				// showMap: false,
				// inputCity: '深圳',
				//字段显示
				// ifAddStation: true,
				//修改主键只能查
				// ifup: false,
				//场站信息是否只能查看
				// ifViewStation: false,

				// showMechant: false,
				// showEvcs: false,

				// EvcsOperators: [],
				//档案-场站管理全部信息
				BreadcrumbList: [this.$tt('主板信息'), '>>', this.$tt('主板档案')],
				formInline: {
					StationId: 0,
					ProductBatchNo: '',
					EquipmentSerialNo: '',
					MachineCode1: '',
					MachineCode2: '',
				},
				// operateColumnWidth: 30,

				//table标题数据
				columns1: [
					{
						title: this.$tt('序号'),
						type: 'index',
						width: 80
					},
					{
						title: this.$tt('生产批次号'),
						key: 'ProductionBatch',
						minWidth: 120
					},
					{
						title: this.$tt('机器码1'),
						key: 'MachineCode1',
						minWidth: 180
					},
					{
						title: this.$tt('机器码2'),
						key: 'MachineCode2',
						minWidth: 180
					},
					{
						title: this.$tt('设备序列号'),
						key: 'EquipmentSerialNo',
						minWidth: 120
					},
					{
						title: this.$tt('设备编码'),
						key: 'EquipmentNo',
						minWidth: 120
					},
					{
						title: this.$tt('软件版本'),
						key: 'SoftVersion',
						minWidth: 80
					},
					{
						title: this.$tt('建档时间'),
						key: 'CreateTime',
						minWidth: 110
					},
				// 	{
				// 		title: '操作',
				// 		key: 'action',
				// 		minWidth: 200,
				// 		align: 'center',
				// 		render: (h, params) => {
				// 			return h('div', [
				// 				this.hasWidgets('edit') ? h('Button', {
				// 					props: {
				// 						type: 'primary',
				// 						size: 'small'
				// 					},
				// 					style: {
				// 						marginRight: '5px',
				// 					},
				// 					on: {
				// 						click: () => {
				// 							this.show("updateStation", params.row.Id)
				// 						}
				// 					}
				// 				}, this.$tt('修改')) : h(),
				// 				this.hasWidgets('view') ? h('Button', {
				// 					props: {
				// 						type: 'primary',
				// 						size: 'small'
				// 					},
				// 					style: {
				// 						marginRight: '5px'
				// 					},
				// 					on: {
				// 						//为了不误操作，确定取消相反
				// 						click: () => {
				// 							this.show("viewStation", params.row.Id)
				// 						}
				// 						// this.show("deleteStation", params.row.Id)
				// 					}
				// 				}, this.$tt('查看')) : h(),
				// 			// 	this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h(
				// 			// 		'Dropdown', {
				// 			// 			on: {
				// 			// 				//为了不误操作，确定取消相反
				// 			// 				'on-click': (name) => {
				// 			// 					this.$Modal.confirm({
				// 			// 						title: name,
				// 			// 						okText: '取消',
				// 			// 						cancelText: '确定',
				// 			// 						onCancel: () => {
				// 			// 							this.otherMethodStation(name,
				// 			// 								params.row.Id);
				// 			// 						}
				// 			// 					});
				// 			// 					// this.show("deleteStation", params.row.Id)
				// 			// 				}
				// 			// 			}
				// 			// 		},
				// 			// 		[
				// 			// 			h('Button', {
				// 			// 				props: {
				// 			// 					type: 'primary',
				// 			// 					size: 'small',
				// 			// 				},
				// 			// 				style: {
				// 			// 					marginRight: '5px'
				// 			// 				},
				// 			// 			}, this.$tt('其他操作')),
				// 			// 			h('DropdownMenu', {
				// 			// 				slot: 'list'
				// 			// 			}, [
				// 			// 				this.methodList.filter(item => this.hasWidgets(item.name))
				// 			// 				.map((
				// 			// 					item) => { // this.productTypeList下拉框里的data
				// 			// 					return h('DropdownItem', {
				// 			// 							props: {
				// 			// 								name: item.Status
				// 			// 							}
				// 			// 						},
				// 			// 						item.Status
				// 			// 					)
				// 			// 				})
				// 			// 			])
				// 			// 		],
				// 			// 	) : h()
				// 			]);
				// 		}
				// 	}
				],
				data1: [],

				// payValue: 0,
				widgets: [],
			};
		},
		async created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight);
			// this.widgets = this.$route.meta.widgets;// await commonFuncs.getWidgetByMenuId(this.$route.meta.menuId);
			// this.widgets.push({Name: 'edit'});
			// this.widgets.push({Name: 'view'});
			// this.widgets.push({Name: 'running'});
			// console.log('widgets', this.widgets);
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			// this.operateColumnWidth = Math.max(60, (36 + (this.hasWidgets('edit') ? 60 : 0) + (this.hasWidgets('view') ?
			// 		60 : 0) +
			// 	(this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? 80 : 0)));
			// this.columns1[this.columns1.length - 1].minWidth = this.operateColumnWidth;
			this.handleSubmit();
			//this.uploadList = this.$refs.upload.fileList;
			// this.GetChargeFronterList();
			// this.getEvcsOperatorList();
			// this.getOccupyPriceList();
			// console.log("useRoute", , this.$router.currentRoute, this.$route, this.$router);
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param;
			},

			//直接选属性
			...mapState({
				// StationList: 'Stations',
				// OperatortypeList: 'typeList',
				// ChargeFronterList: 'chargeFronterList',
				// PayeeMerchant: 'PayeeMerchant'
			})
		},
		methods: {
			...mapActions([
				// 'GetUserStations',
				// 'GetChargeFronterList'
			]),
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			// //操作按钮
			// show: function(type, params) {
			// 	switch (type) {
			// 		case "addStation":
			// 			this.modal.type = "addStation";
			// 			this.modal.Title = this.$tt('场站添加');
			// 			this.ifup = false
			// 			this.ifViewStation = false
			// 			this.modalCancel();
			// 			break;
			// 		case "updateStation":
			// 			this.modal.type = "updateStation";
			// 			this.modal.Title = this.$tt('场站信息修改');
			// 			this.ifup = true
			// 			this.getUpdateMessage(params);
			// 			this.ifViewStation = false
			// 			break;
			// 		case "viewStation":
			// 			this.modal.type = "viewStation";
			// 			this.modal.Title = this.$tt('场站信息查看');
			// 			this.getUpdateMessage(params);
			// 			this.ifup = true
			// 			this.ifViewStation = true
			// 			break;
			// 	}
			// 	this.modalView = true;

			// },
			// //modal取消操作
			// cancelPictures: function() {
			// 	const _this = this
			// 	_this.PictureUpCache = []
			// 	if (_this.PictureDelCache.length > 0) {
			// 		console.log("取消添加或跟新，删除添加的图片")
			// 		let picsArr = _this.PictureDelCache
			// 		let StationPictures = ''
			// 		for (let i = 0; i < picsArr.length; i++) {
			// 			if (i == (picsArr.length - 1)) {
			// 				StationPictures += picsArr[i]
			// 			} else {
			// 				StationPictures += picsArr[i] + ','
			// 			}
			// 		}
			// 		_this.deletePicture(StationPictures)
			// 	}
			// },
			// //删除修改之外的其他操作
			// otherMethodStation: function(name, Id) {
			// 	let typeNum = (this.methodList.filter(function(item, index, arr) {
			// 		return item.Status == name
			// 	})[0]).id
			// 	console.log(typeNum)
			// 	this.$axios.post(webapi.SetStationStatus, {
			// 		Id: Id,
			// 		Status: typeNum
			// 	}).then(res => {
			// 		if (res.data.Code == 0) {
			// 			this.$Message.info(name + this.$tt('成功'));
			// 			this.handleSubmit()
			// 		}
			// 	})
			// },
			// deleteStation: function() {
			// 	const _this = this;
			// 	_this.$axios.post(webapi.base_api_url + "/Overview/###", {}).then(res => {
			// 		if (res.data.code != 1 && res.data.Data != null) {
			// 			this.$Message.info(this.$tt('删除成功'));
			// 		}
			// 	})
			// },
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				// this.$refs.sonPage.getList();
				this.$refs.table.getData();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},

			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 1376 ? 40 : 0);
			},
			// modalCancel: function() {
			// 	this.uploadList = []
			// 	this.$nextTick(() => {
			// 		this.$refs.StationForm.resetFields();
			// 		this.$refs.upload.clearFiles();
			// 		this.defaultList = this.$refs.upload.fileList
			// 	})
			// },
			// getUpdateMessage: function(Id) {
			// 	console.log(Id);
			// 	const _this = this;
			// 	for (let i = 0; i < _this.data1.length; i++) {
			// 		if (_this.data1[i].Id == Id) {
			// 			_this.StationForm = Object.assign({}, _this.data1[i])
			// 			let picList = [];
			// 			let arr = _this.data1[i].StationPicturesArray
			// 			for (let i = 0; i < arr.length; i++) {
			// 				let url = ''
			// 				// if (process.env.NODE_ENV === "development") {
			// 				// 	url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+arr[i];
			// 				// }else {
			// 				//   url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+arr[i];
			// 				// }
			// 				url = webapi.base_api_url + arr[i];
			// 				let picture = {
			// 					name: arr[i],
			// 					url: url
			// 				}
			// 				picList.push(picture)
			// 			}
			// 			_this.defaultList = picList
			// 			_this.$nextTick(() => {
			// 				// dom元素更新后执行，因此这里能正确打印更改之后的值
			// 				_this.uploadList = _this.$refs.upload.fileList
			// 			})
			// 		}
			// 	}
			// },
			// //新增||修改
			// modalOk: function(type) {
			// 	const _this = this
			// 	switch (type) {
			// 		case "add":
			// 			_this.StationForm.Id = 0
			// 			break;
			// 		case "up":
			// 			let picsArr = _this.PictureUpCache
			// 			if (picsArr.length > 0) {
			// 				let StationPictures = ''
			// 				for (let i = 0; i < picsArr.length; i++) {
			// 					if (i == (picsArr.length - 1)) {
			// 						StationPictures += picsArr[i]
			// 					} else {
			// 						StationPictures += picsArr[i] + ','
			// 					}
			// 				}
			// 				_this.deletePicture(StationPictures)
			// 			}
			// 			break;
			// 	}
			// 	_this.PictureDelCache = [];
			// 	_this.PictureUpCache = [];
			// 	let picsArr = _this.StationForm.StationPicturesArray
			// 	_this.StationForm.StationPictures = ''
			// 	for (let i = 0; i < picsArr.length; i++) {
			// 		if (i == (picsArr.length - 1)) {
			// 			_this.StationForm.StationPictures += picsArr[i]
			// 		} else {
			// 			_this.StationForm.StationPictures += picsArr[i] + ','
			// 		}
			// 	}
			// 	const param = _this.StationForm
			// 	this.$refs.StationForm.validate((valid) => {
			// 		console.log("场站" + type + "----" + valid)
			// 		if (valid) {
			// 			_this.$axios.post(webapi.base_api_url + '/Archives/AddStation',
			// 				param
			// 			).then(res => {
			// 				console.log(res)
			// 				if (res.data.Code == 0) {
			// 					this.$Message.info(this.$tt('场站') + type + this.$tt('成功'));
			// 					this.$refs.sonPage.getList();
			// 					// this.$refs.table.getData();
			// 					this.modalView = false;
			// 					this.GetUserStations()
			// 				} else {
			// 					this.$Message.info(this.$tt('场站') + type + this.$tt('失败'));
			// 				}
			// 			})
			// 		}
			// 	})
			// },

			// OperatorNameChange: function(a) {
			// 	let Operatortype = this.OperatortypeList.filter(function(item, index, arr) {
			// 		return item.Name == a
			// 	})
			// 	this.StationForm.OperatorId = Operatortype[0].Id;
			// },
			// getEvcsOperatorList: function() {
			// 	this.$axios.post(webapi.base_api_url + '/Common/GetEvcsOperatorList').then(res => {
			// 		if (res.status == 200 && res.data.Code == 0) {
			// 			this.EvcsOperators = res.data.Data.List;
			// 		}
			// 	})
			// },
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 16px;
	}

	.ivu-form-item-error-tip {
		padding-top: 0;
	}

	/* 	.ivu-col {
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
	}
 */
	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>